import { render, staticRenderFns } from "./MapShortcuts.vue?vue&type=template&id=5a7de15c"
import script from "./MapShortcuts.vue?vue&type=script&lang=js"
export * from "./MapShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports